import { render } from "./TableInvoice.vue?vue&type=template&id=d85e2b8e"
import script from "./TableInvoice.vue?vue&type=script&lang=ts"
export * from "./TableInvoice.vue?vue&type=script&lang=ts"
script.render = render

export default script